import { useUpdateProject } from 'api/ProjectsAPI';
import { useCustomEventsQueryContext } from 'modules/customEvents/contexts';
import { ProjectDataSettings } from 'modules/domains';
import { RUMHelpers } from 'services/observability/datadog';
import { Product, Team } from 'teams';

export const useUpdateProjectSettings = () => {
  const { project, refetchProject } = useCustomEventsQueryContext();
  const { mutate: updateSettings } = useUpdateProject(project.id, {
    onError: (axiosError: any) => {
      const { error = '', message = '' } = axiosError?.response?.data || {};
      const errorMessage =
        'Error updating extendedProjectSettings after changing visibility on userHiddenFields or purchaseHiddenFields';
      /** log error internally since Mapping tracker is source of truth for fields */
      RUMHelpers.addRUMError(
        new Error(),
        {
          name: 'useUpdateProjectSettings',
          productName: Product.SETTINGS,
          teamName: Team.PLATFORM_TEAM,
        },
        {
          errorMessage,
          error,
          message,
        },
      );
    },
    onSuccess: () => {
      refetchProject();
    },
  });

  const defaultDataSettings: ProjectDataSettings = {
    allowNewCustomEvents: Boolean(project?.extendedProjectSettings?.allowNewCustomEvents),
    allowAutoCustomEventFieldCreation: Boolean(project?.allowAutoCustomEventFieldCreation),
    allowAutoUserFieldCreation: Boolean(project?.allowAutoUserFieldCreation),
    purchaseHiddenFields: project?.extendedProjectSettings?.purchaseHiddenFields || [],
    userHiddenFields: project?.extendedProjectSettings?.userHiddenFields || [],
  };

  return { defaultDataSettings, updateSettings };
};
